import React from "react";
import {
  DocumentCard,
  DocumentCardDetails,
  DocumentCardTitle,
  DocumentCardActivity,
  DocumentCardLocation,
} from "@fluentui/react";
import { ApproverDialog } from "./ApproverDialog";
import OwnerChange from "./ChangeValues/OwnerChange";
import { ChangeTaskType } from "../../GlobalConst/globalEnums";
import QuotaChangeTask from "./ChangeValues/QuotaChangeTask";

class ApproveChangeTask extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showApproveDialog: false,
    };
  }

  _mapOwnerForPeople(user) {
    return user ? [{ name: user.displayName }] : [];
  }

  _onLocationClick = (e) => {
    e.stopPropagation();
    e.preventDefault();

    window.open(e.target.href, "_blank");
  };

  render() {
    const { change } = this.props;

    let cardTitle = "";
    let changeDetailsComponent = null;

    switch (change.type) {
      case ChangeTaskType.owner:
      case ChangeTaskType.emptyOwner:
        cardTitle = "Owner change";
        changeDetailsComponent = (
          <OwnerChange
            owners={change.site.owners}
            newOwner={change.changeDbObject}
          />
        );
        break;
      case ChangeTaskType.quota:
        cardTitle = "Quota change";
        changeDetailsComponent = <QuotaChangeTask change={change} />;
        break;
      case ChangeTaskType.delete:
        cardTitle = "Site deletion request";
        changeDetailsComponent = (
          <div style={{ padding: "8px 8px" }}>
            <strong>Deletion Reason:</strong>
            <p style={{ margin: "5px 0" }}>
              {change.changeQuotaComment || "No reason provided."}
            </p>
            {change.site.siteTemplate.id === 6 && (
              <p style={{ color: "red" }}>
                This site is associated with a template R&D Archive.
              </p>
            )}
          </div>
        );
        break;
      default:
        cardTitle = "Unknown change type";
        changeDetailsComponent = (
          <div>Details for this change type are not available.</div>
        );
    }

    return (
      <div>
        <DocumentCard styles={cardStyles}>
          <DocumentCardDetails styles={detailsStyles}>
            <div style={titleStyles}>
              <DocumentCardTitle title={cardTitle} shouldTruncate={false} />{" "}
              {/* Używamy zmiennej cardTitle */}
            </div>
            <DocumentCardLocation
              styles={urlStyles}
              location={change.site.url}
              locationHref={change.site.url}
              onClick={this._onLocationClick}
            />
            {changeDetailsComponent}{" "}
            {/* Używamy zmiennej changeDetailsComponent */}
          </DocumentCardDetails>
          {change.type === ChangeTaskType.emptyOwner ? ( // Użyj change.type, a nie change.label
            <div style={createdByStyles}>
              Change initiated by automatic process due to current owner
              disabled account.
            </div>
          ) : (
            change.createdBy && (
              <div style={createdByStyles}>
                <div>Change requested by: </div>
                <DocumentCardActivity
                  activity={`Created on ${new Date(
                    change.requestDate
                  ).toLocaleString()}`}
                  people={this._mapOwnerForPeople(change.createdBy)}
                />
              </div>
            )
          )}
          <div style={iconContainerStyles}>
            <ApproverDialog
              btnStyle={btnEditStyles}
              buttonName="Decision"
              title="Approve or reject site change"
              onReject={this.props.onReject}
              onApprove={this.props.onApprove}
            />
          </div>
        </DocumentCard>
      </div>
    );
  }
}
const urlStyles = {
  root: {
    color: "rgb(0, 120, 212)",
    fontSize: "14px",
    // fontWeight: 'bold',
    whiteSpace: "normal",
    overflowWrap: "break-word",
    paddingTop: 0,
  },
};

const createdByStyles = {
  padding: "8px",
  fontSize: "12px",
  flex: 1,
};

const btnEditStyles = {
  root: {
    width: "100%",
  },
};

const iconContainerStyles = {
  display: "flex",
  flexDirection: "column",
};
const titleStyles = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  maxHeight: "35px",
};

const cardStyles = {
  root: {
    marginRight: 20,
    marginBottom: 20,
    width: 400,
    height: 300,
    display: "flex",
    flexDirection: "column",
  },
};

const detailsStyles = {
  root: {
    height: 235,
    flex: 5,
    justifyContent: "start",
  },
};

export default ApproveChangeTask;



// WEBPACK FOOTER //
// ./src/components/ManageCenter/ApproveChangeTask.js